export default __webpack_public_path__ + "static/media/logorouge.4ac455c8.png";